/* eslint-disable import-helpers/order-imports */
import React from "react";

import ArticlesGrid, { StaticArticlesGrid } from "@sections/ArticlesGrid";
import Hero from "@sections/Hero";
import ImageContainer from "@sections/ImageContainer";
import PanelImage from "@sections/PanelImage";
import Form from "@sections/Form";
import PeopleList from "@sections/PeopleList";
import ContainerGrid from "@sections/ContainerGrid";
import ContainerGridAccordion from "@sections/ContainerGridAccordion";
import ContainerTable from "@sections/ContainerTable";
import LocationList from "@sections/LocationList";
import ScoreOverview from "@sections/ScoreOverview";
import CardsGrup from "@sections/CardsGroup";
import ContainerRows from "@sections/ContainerRows";
import { SectionHero } from "@sections/SectionHero";
import { SectionTop5 } from "@sections/SectionTop5";
import { SectionTabs } from "@sections/SectionTabs";
import { SectionDuplex } from "@sections/SectionDuplex";
import { SectionBenefits } from "@sections/SectionBenefits";
import { SectionCardList } from "@sections/SectionCardList";
import { SectionTrustbar } from "@sections/SectionTrustbar";
import { SectionAccordion } from "@sections/SectionAccordion";

type ModuleProps = {
  __typename: string;
  contentful_id: string;
};

type ModuleSelectorProps = {
  modules: ModuleProps[];
  extras?;
  useStaticArticlesGrid?: boolean;
};

const ModuleSelector = ({
  modules,
  extras,
  useStaticArticlesGrid = false,
}: ModuleSelectorProps): JSX.Element => {
  if (modules) {
    return (
      <>
        {modules.map((module: ModuleProps, index: number) => {
          const key = `${module?.contentful_id}-${index}`;
          if (!module?.contentful_id) return <React.Fragment key={key} />;
          // eslint-disable-next-line no-underscore-dangle
          switch (module.__typename) {
            case "ContentfulHero":
              return (
                <Hero key={key} extra={extras?.ContentfulHero} item={module} />
              );
            case "ContentfulPanelImage":
              return (
                <PanelImage
                  key={key}
                  extra={extras?.ContentfulPanelImage}
                  item={module}
                />
              );
            case "ContentfulImageContainer":
              return (
                <ImageContainer
                  key={key}
                  extra={extras?.ContentfulImageContainer}
                  item={module}
                />
              );
            case "ContentfulArticlesGrid": {
              if (useStaticArticlesGrid) {
                return <StaticArticlesGrid key={key} entry={module} />;
              }
              return (
                <ArticlesGrid
                  key={key}
                  extra={extras?.ContentfulArticlesGrid}
                  item={module}
                />
              );
            }
            case "ContentfulForm":
              return (
                <Form key={key} extra={extras?.ContentfulForm} item={module} />
              );
            case "ContentfulPeopleList":
              return (
                <PeopleList
                  key={key}
                  extra={extras?.ContentfulPeopleList}
                  item={module}
                />
              );
            case "ContentfulContainerGrid":
              return (
                <ContainerGrid
                  key={key}
                  extra={extras?.ContentfulContainerGrid}
                  item={module}
                />
              );
            case "ContentfulContainerGridAccordion":
              return (
                <ContainerGridAccordion
                  key={key}
                  extra={extras?.ContentfulContainerGridAccordion}
                  item={module}
                />
              );
            case "ContentfulContainerTable":
              return (
                <ContainerTable
                  key={key}
                  extra={extras?.ContentfulContainerTable}
                  item={module}
                />
              );
            case "ContentfulLocationList":
              return (
                <LocationList
                  key={key}
                  extra={extras?.ContentfulLocationList}
                  item={module}
                />
              );
            case "ContentfulScoreOverview":
              return (
                <ScoreOverview
                  key={key}
                  extra={extras?.ContentfulScoreOverview}
                  item={module}
                />
              );
            case "ContentfulCardsGroup":
              return (
                <CardsGrup
                  key={key}
                  extra={extras?.ContentfulCardsGroup}
                  item={module}
                />
              );
            case "ContentfulContainerRows":
              return (
                <ContainerRows
                  key={key}
                  extra={extras?.ContentfulContainerRows}
                  item={module}
                />
              );
            case "ContentfulSectionHero": {
              return (
                <SectionHero key={key} entry={module} isGrt={extras?.isGrt} />
              );
            }
            case "ContentfulSectionTop5": {
              return <SectionTop5 key={key} entry={module} />;
            }
            case "ContentfulSectionTabs": {
              return <SectionTabs key={key} entry={module} />;
            }
            case "ContentfulSectionDuplex": {
              return <SectionDuplex key={key} entry={module} />;
            }
            case "ContentfulSectionBenefits": {
              return <SectionBenefits key={key} entry={module} />;
            }
            case "ContentfulSectionCardList": {
              return <SectionCardList key={key} entry={module} />;
            }
            case "ContentfulSectionTrustbar": {
              return <SectionTrustbar key={key} entry={module} />;
            }
            case "ContentfulSectionAccordion": {
              return <SectionAccordion key={key} entry={module} />;
            }
            default:
              return <React.Fragment key={key} />;
          }
        })}
      </>
    );
  }
  return <></>;
};

export default ModuleSelector;
